import { useQuery } from '@tanstack/react-query';

import { clientsService } from '../services';

import { clientsKeys } from './useClients';

export function useClientAssessments(clientId: string | undefined) {
  return useQuery({
    queryKey: clientsKeys.operation('assessments', clientId ?? ''),
    queryFn: () => {
      if (!clientId) throw new Error('missing id');
      return clientsService.listAssessments(clientId);
    },
    enabled: Boolean(clientId),
  });
}
